import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_detail_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { projectId: number }): Promise<{ result?: { data?: { Material_Project_LookupCode?: string, Material_Name?: string, Material_Description?: string, Location_Name?: string, ExpirationDate?: string, VendorLot_LookupCode?: string, LicensePlate_LookupCode?: string, AllocatedPackagedAmount?: number, IncomingPackagedAmount?: number, InactivePackagedAmount?: number, LicensePlateStatus_Name?: string, AvailablePackagedAmount?: number, TotalPackagedAmount?: number, orderLookup?: string, LicensePlate_GrossWeight?: number, LicensePlate_NetWeight?: number, orderOwnerReference?: string, Lot_ReceiveDate?: string }[] } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      projectId: number    }) {
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
